import { SagasProxy, RestApiProxy } from 'com-gyf-webcore-servicehub';

let ContabilidadManager = function () {
    function ejecutarSagasContabilidad(data, sagasCallback, viewCallback, nombreSaga) {
        let localValues = generarLocalValues(data, nombreSaga);

        ejecutarSagas(localValues, nombreSaga, sagasCallback, viewCallback);
    }

    function ejecutarSagas(localValues, saga, sagasCallback, viewCallback) {
        SagasProxy.AddSagaRequests(localValues, saga, "TARJETAS", "CONTABILIDAD");

        RestApiProxy.SetApiUrl();

        SagasProxy.Execute(sagasCallback, undefined, viewCallback, "CONTABILIDAD");
    }

    function generarLocalValues(data, nombreSaga) {
        let localValues = undefined;

        switch (nombreSaga) {
            case "SAGA_REEMPLAZAR_CUENTA_CONTABLE":
                localValues = {
                    "MODELO_DETALLE_CONTAINER": data
                }

                break;
            case "SAGA_ABM_MODELO_CONTABLE":
                localValues = {
                    "MODELO_CABECERA_CONTAINER": data.MODELO_CABECERA_CONTAINER,
                    "MODELO_DETALLE_CONTAINER": data.MODELO_DETALLE_CONTAINER,
                    "MODELO_DETALLE_CRITERIO_CONTAINER": data.MODELO_DETALLE_CRITERIO_CONTAINER
                }

                break;
            //HACER UNA SAGA SOLO PARA LA BAJA QUE ACTUALICE SOLAMENTE MODELO_CONTABLE_CABECERA.FechaBaja
            default:
                break;
        }

        return localValues;
    }

    return {
        EjecutarSagasContabilidad: function (data, sagasCallback, viewCallback, nombreSaga) {
            return ejecutarSagasContabilidad(data, sagasCallback, viewCallback, nombreSaga);
        },

    }
};

let contabilidadManager = new ContabilidadManager();

export default contabilidadManager;